import React from 'react';
import { defaultTemplate } from 'core/hoc';
import { YesNoViewNewTemplate } from 'themes/components';

function YesNoViewNew(props) {
    return <YesNoViewNewTemplate {...props} />
}

export default defaultTemplate(YesNoViewNew);